import _isEmpty from 'lodash/isEmpty';
import _findIndex from 'lodash/findIndex';
import { eventArrayMapping, overallTypes } from '../utils/calendarConstants';

export default {
  data() {
    return {
      calendarDailyData: [],
      calendarDailyType: 'MIXED',
    };
  },
  methods: {
    getCalendarDailyData(type, date) {
      const eventDate = date;
      const eventType = type;

      const eventTypeKey = eventArrayMapping[eventType];

      const overallType = overallTypes[eventType];

      if (_isEmpty(this[eventTypeKey])) {
        this.calendarDailyData = [];
        this.calendarDailyType = overallType;
      } else {
        const index = _findIndex(this[eventTypeKey], function(event) {
          return event.date_key === eventDate;
        });

        if (index >= 0) {
          try {
            this.calendarDailyData = this[eventTypeKey][index].flattenedArrayData;
            this.calendarDailyType = this[eventTypeKey][index].type;
          } catch (err) {
            this.calendarDailyData = [];
            this.calendarDailyType = overallType;
          }
        } else {
          this.calendarDailyData = [];
          this.calendarDailyType = overallType;
        }
      }
    },
  },
};
